angular.module('controllers').controller('permissionController', ['$scope', '$rootScope', '$controller', 'Crud',
    function ($scope, $rootScope, $controller, Crud) {
        $rootScope.path = '/permission';
        $scope.path = $rootScope.path;
        $rootScope.modelName = 'permission';
        $scope.pathTemplate = 'users/permissions';
        $scope.title = 'Permisiuni';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $scope.sortType = 'id';
        $scope.defaultItem = 10;
        $rootScope.typeId = 'id';
        $scope.search.order = 'asc';
        $scope.classAction = 'td-big';
        $scope.columns = {
            //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
            'permission_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
            'permission_slug':{'label':'Slug', 'filter':1, 'filterType':'input'},
            'permission_label':{'label':'Eticheta permisiune', 'filter':1, 'filterType':'input'},
            'permission_controller':{'label':'Controler', 'filter':1, 'filterType':'select'},
            'permission_controller_label':{'label':'Eticheta controler', 'filter':1, 'filterType':'input'},
            'status':{'label':'Status', 'filter':1, 'filterType':'select'}
        };

        $scope.columns.status.options = [
            {'id':'', 'value' : ''},
            {'id':1, 'value' : 'true'},
            {'id':0, 'value' : 'false'}
        ];

        $scope.additionals = {};
        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'permission_name';

        /* get dependent fields */
        $scope.getDependedFields = function () {
            Crud.getDependedFields($scope.path)
                .success(function (data) {
                    $scope.additionals['controllers'] = [];
                    angular.extend($scope.additionals['controllers'], data.controllers);

                    $scope.columns.permission_controller.options = [{id:'', value:''}];
                    angular.extend($scope.columns.permission_controller.options, data.controllers);
                });
        }

        $scope.additionals['searchTerm'];
        $scope.additionals['clearSearchTerm'] = function() {
            $scope.additionals['searchTerm'] = '';
        };
        $scope.additionals['onSearchChange'] = function(ev) {
            ev.stopPropagation();
        };

        $scope.managePermissions = function () {
            $scope.additionals['invalid'] = '';
            Crud.get($scope.path+'/managepermissions')
                .success(function (data) {
                    if (!angular.isUndefined(data.invalid)) {
                        $scope.additionals['invalid'] = data.invalid;
                    } else {
                        $scope.message = data.message;
                    }
                });

        }

    }]
)

